import { AppInitializer } from "@callcenter-frontend/app-initializer"
import { preloadDesignSystemLocalization } from "@callcenter-frontend/preloadLocalization"

const loadLocalizationService = import("@callcenter/services").then((modules) => modules.localizationService)

const setupLocalization = async (pageNames: Array<string>) => {
  const localizationService = await loadLocalizationService

  await localizationService.preloadLocalization(pageNames)
  await preloadDesignSystemLocalization()
}

const loadServices = () => import(/* webpackChunkName: "Services" */ "@callcenter/services")
const loadEffectorServices = () => import(/* webpackChunkName: "EffectorServices" */ "@callcenter/effector-services")

export const AUTHORIZATION_PAGES = ["login", "two-factor-auth-new"] as const

export const setupWebAppServices = async (pageNames: Array<string>, appInitializer: AppInitializer) => {
  for (const page of AUTHORIZATION_PAGES) {
    const element = document.querySelector(`[data-app='${page}']`)

    if (element) {
      import("@callcenter-frontend/authorization").then((module) => {
        module.init(element as HTMLElement, page)
      })

      return page
    }
  }

  await setupLocalization(pageNames)

  const [services, effectorServices] = await Promise.all([loadServices(), loadEffectorServices()])

  const isTosConsent = await AppInitializer.initTosConsent()

  effectorServices.$webAppService.$ready.watch(async (isReady) => {
    if (!isReady || isTosConsent) {
      return
    }

    await AppInitializer.initSelfService()
    await AppInitializer.showHeaderAfterLoadChunk()

    await appInitializer.initAll()
  })

  effectorServices.$webAppService.loaded()
  effectorServices.initCrossTabChannelFx()

  if (isTosConsent) {
    return "tos_consent"
  }

  services.serverTimeService.resetTime()
}
